import type { CSSProperties } from 'react';
import type { NavLinkProps } from 'react-router-dom';
import { NavLink as RouterLink } from 'react-router-dom';
import type { LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import { Link as ChakraLink } from '@chakra-ui/react';

type Props = Omit<ChakraLinkProps, 'href'> & NavLinkProps & { activeStyle?: CSSProperties };

export const Link = ({ children, activeStyle, ...props }: Props) => {
  return (
    <ChakraLink
      as={RouterLink}
      role='link'
      _activeLink={activeStyle}
      {...props}
      // aria-current={isActive ? 'page' : undefined}
    >
      {children}
    </ChakraLink>
  );
};
